class CountdownComponent extends HTMLElement {
  constructor() {
    super();
    this.timer = null;
  }

  connectedCallback() {
    this.daysSpan = this.querySelector('.countdown-component__days');
    this.hoursSpan = this.querySelector('.countdown-component__hours');
    this.minutesSpan = this.querySelector('.countdown-component__minutes');
    this.secondsSpan = this.querySelector('.countdown-component__seconds');
    this.targetDate = this.getAttribute('data-target-date');

    if (this.targetDate) {
      this.startCountdown();
    }
  }

  disconnectedCallback() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }

  startCountdown() {
    const targetTime = new Date(this.targetDate).getTime();

    if (isNaN(targetTime)) {
      console.error('Invalid target date:', this.targetDate);
      return;
    }

    const update = () => {
      const now = new Date().getTime();
      const distance = targetTime - now;

      if (distance < 0) {
        clearInterval(this.timer);
        this.updateDisplay(0, 0, 0, 0);
        this.classList.add('expired');
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      this.updateDisplay(days, hours, minutes, seconds);
    };

    update(); // Run immediately
    this.timer = setInterval(update, 1000);
  }

  updateDisplay(days, hours, minutes, seconds) {
    if (this.daysSpan) this.daysSpan.textContent = this.formatNumber(days);
    if (this.hoursSpan) this.hoursSpan.textContent = this.formatNumber(hours);
    if (this.minutesSpan) this.minutesSpan.textContent = this.formatNumber(minutes);
    if (this.secondsSpan) this.secondsSpan.textContent = this.formatNumber(seconds);
  }

  formatNumber(number) {
    return number < 10 ? `0${number}` : number;
  }
}

customElements.define('countdown-component', CountdownComponent);
